import styled from '@emotion/styled'

export const DrawerHeader = styled.header`
  height: 70px;
  width: 100%;
  background-color: #0091ff;
  color: white;
  display: flex;
  align-items: center;
  gap: 15px;
  padding-left: 30px;
`

export const DrawerHeaderTitle = styled.div`
  font-size: 14px;
  font-weight: bold;
`
